import React from "react";
import { cn } from "@/lib/utils";

/**
 * Abonelik İptal brand mark — document + coral pen icon paired with a text wordmark.
 */
export const FeshetIcon = ({ size = 32, className, ...props }) => {
  return (
    <img
      src="/branding/abonelik-iptal/logo192.png"
      width={size}
      height={size}
      alt=""
      className={cn("shrink-0 object-contain", className)}
      aria-hidden="true"
      decoding="async"
      draggable="false"
      {...props}
    />
  );
};

export const Wordmark = ({ className, size = "md", showIcon = true, ...props }) => {
  const cfg = {
    sm: { text: "text-base sm:text-lg", icon: 22, gap: "gap-1.5 sm:gap-2" },
    md: { text: "text-[17px] sm:text-xl md:text-[24px]", icon: 28, gap: "gap-1.5 sm:gap-2.5" },
    lg: { text: "text-5xl md:text-6xl", icon: 56, gap: "gap-4" },
  }[size];

  return (
    <span
      data-testid="feshet-wordmark"
      className={cn("inline-flex min-w-0 items-center", cfg.gap, className)}
      {...props}
    >
      {showIcon && <FeshetIcon size={cfg.icon} />}
      <span
        className={cn(
          "whitespace-nowrap text-[#0F3D4A] leading-none",
          cfg.text,
        )}
        style={{
          fontFamily: '"DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          fontWeight: 600,
          letterSpacing: "-0.025em",
        }}
      >
        Abonelik İptal
      </span>
    </span>
  );
};

export default Wordmark;
